import React, { useState, useEffect } from 'react';
import { updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import Swal from 'sweetalert2';

const EditCargoModal = ({ isOpen, onClose, refreshTable, initialCargo }) => {
  const [editedCargo, setEditedCargo] = useState(initialCargo);

  useEffect(() => {
    setEditedCargo(initialCargo);
  }, [initialCargo]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateDoc(doc(db, 'cargo', editedCargo.id), {
        tracking_id: editedCargo.tracking_id,
        user_name: editedCargo.user_name,
        from_country: editedCargo.from_country,
        to_country: editedCargo.to_country,
        date: new Date(editedCargo.date),
        last_update: new Date(editedCargo.last_update),
        status: editedCargo.status,
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Cargo updated successfully!',
      });

      refreshTable();
      onClose();
    } catch (error) {
      console.error('Error updating document:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update cargo. Please try again later.',
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedCargo((prevCargo) => ({
      ...prevCargo,
      [name]: value,
    }));
  };

  return (
    <div
      className={`${isOpen ? 'block' : 'hidden'} fixed z-10 inset-0 overflow-y-auto`}
    >
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-lg p-8">
          <h2 className="text-2xl font-bold mb-4">Edit Cargo</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="trackingId">Tracking ID:</label>
              <input
                type="text"
                name="tracking_id"
                value={editedCargo.tracking_id}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="userName">User Name:</label>
              <input
                type="text"
                name="user_name"
                value={editedCargo.user_name}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="fromCountry">From Country:</label>
              <input
                type="text"
                name="from_country"
                value={editedCargo.from_country}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="toCountry">To Country:</label>
              <input
                type="text"
                name="to_country"
                value={editedCargo.to_country}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                name="date"
                value={editedCargo.date}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="lastUpdate">Last Update:</label>
              <input
                type="date"
                name="last_update"
                value={editedCargo.last_update}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="status">Status:</label>
              <input
                type="text"
                name="status"
                value={editedCargo.status}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-indigo-500"
                required
              />
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={onClose}
                className="mr-4 px-4 py-2 text-white bg-gray-500 rounded hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-indigo-500 rounded hover:bg-indigo-600"
              >
                Update Cargo
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCargoModal;
